import { render, staticRenderFns } from "./SignUpSocial.htm?vue&type=template&id=6bfad7f3&scoped=true&"
import script from "./SignUpSocial.ts?vue&type=script&lang=js&"
export * from "./SignUpSocial.ts?vue&type=script&lang=js&"
import style0 from "./SignUpSocial.scss?vue&type=style&index=0&id=6bfad7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfad7f3",
  null
  
)

export default component.exports